/**
 * Adaptive difficulty as a transparent "3-up / 2-down" staircase (F-LEARN-06):
 * - 3 correct answers in a row → level up (max 4), streak resets.
 * - 2 wrong answers among the last 3 at this level → level down (min 1).
 * No machine learning; the rule is shown to the learner.
 */
import { MAX_LEVEL } from "./exercises";

export interface StaircaseState { level: number; streak: number; recent: boolean[]; }

export const INITIAL_STAIRCASE: StaircaseState = { level: 1, streak: 0, recent: [] };
export const STAIRCASE_RULE = "3 correct in a row moves you up a level; 2 misses in your last 3 answers moves you down.";

export function nextStaircase(s: StaircaseState, correct: boolean): StaircaseState {
  const recent = [...s.recent, correct].slice(-3);
  const streak = correct ? s.streak + 1 : 0;
  if (streak >= 3 && s.level < MAX_LEVEL) return { level: s.level + 1, streak: 0, recent: [] };
  if (recent.filter((r) => !r).length >= 2 && s.level > 1) return { level: s.level - 1, streak: 0, recent: [] };
  return { level: s.level, streak: correct ? Math.min(streak, 3) : 0, recent };
}
